module.exports = __webpack_public_path__ + "img/bravo.1927d3a1.svg";